import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IListInstituicao } from '../../interfaces/instituicao';

/*
  Generated class for the InstituicaoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class InstituicaoProvider {
  baseUrl = environment.API_URL;
  constructor(public http: HttpClient) {}

  getDadosServidor() {
    return this.http
      .get<any>(this.baseUrl + '/instituicao/dados', {
        params: {
          expand: 'contato,endereco,links,nomenclatura,configPortalAplicativo',
        },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getImagemFundo() {
    return this.http.get<any>(this.baseUrl + '/instituicao/imagem-fundo');
  }

  getInstituicaoList(filtro, pag) {
    return this.http
      .get<any>(this.baseUrl + '/instituicao/instituicao-list', {
        observe: 'response',
        params: {
          page: pag.currentPage,
          'per-page': '10',
          filtro: filtro,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          instituicao: data.body,
          pagination: pag,
        };
      });
  }

  getInstituicoesVinculadas() {
    return this.http
      .get<IListInstituicao[]>(this.baseUrl + '/instituicao/get-instituicoes-vinculadas', {
        observe: 'response'
      })
      .map((data) => {
        return data.body;
      });
  }

  criarSolicitacao(mensagem, tipo) {
    return this.http
      .post<any>(this.baseUrl + '/instituicao/solicitacao', {
        mensagem: mensagem,
        tipo: tipo,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  public getInstituicaoCadastro(id) {
    return this.http.post<any>(this.baseUrl + '/cadastro/get-instituicao', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  public hasConfigSede(idConfiguracao: string) {
    return this.http
    .get<boolean>(this.baseUrl + '/instituicao/has-config-sede', {
      params: {
        idConfiguracao: idConfiguracao
      },
    })
    .map((data) => {
      return data;
    });
  }

  public compareInstituicoes(idInstituicaoLeitor, parsedQrCodeIdInstituicao) {
    return this.http
    .get<boolean>(this.baseUrl + '/instituicao/compare-instituicoes', {
      params: {
        idInstituicaoLeitor: idInstituicaoLeitor,
        parsedQrCodeIdInstituicao: parsedQrCodeIdInstituicao
      },
    })
    .map((data) => {
      return data;
    });
  }

  public objDddi() {
    return {
      '+247': 'ac',
      '+376': 'ad',
      '+971': 'ae',
      '+93': 'af',
      '+355': 'al',
      '+374': 'am',
      '+599': 'an',
      '+244': 'ao',
      '+672': 'aq',
      '+54': 'ar',
      '+43': 'at',
      '+61': 'au',
      '+297': 'aw',
      '+994': 'az',
      '+387': 'ba',
      '+880': 'bd',
      '+32': 'be',
      '+226': 'bf',
      '+359': 'bg',
      '+973': 'bh',
      '+257': 'bi',
      '+229': 'bj',
      '+673': 'bn',
      '+591': 'bo',
      '+55': 'br',
      '+975': 'bt',
      '+267': 'bw',
      '+375': 'by',
      '+501': 'bz',
      '+243': 'cd',
      '+236': 'cf',
      '+242': 'cg',
      '+41': 'ch',
      '+225': 'ci',
      '+682': 'ck',
      '+56': 'cl',
      '+237': 'cm',
      '+86': 'cn',
      '+57': 'co',
      '+506': 'cr',
      '+53': 'cu',
      '+238': 'cv',
      '+357': 'cy',
      '+420': 'cz',
      '+49': 'de',
      '+253': 'dj',
      '+45': 'dk',
      '+213': 'dz',
      '+593': 'ec',
      '+372': 'ee',
      '+20': 'eg',
      '+291': 'er',
      '+34': 'es',
      '+251': 'et',
      '+358': 'fi',
      '+679': 'fj',
      '+500': 'fk',
      '+691': 'fm',
      '+298': 'fo',
      '+590': 'fr',
      '+241': 'ga',
      '+995': 'ge',
      '+594': 'gf',
      '+233': 'gh',
      '+350': 'gi',
      '+299': 'gl',
      '+220': 'gm',
      '+224': 'gn',
      '+240': 'gq',
      '+30': 'gr',
      '+502': 'gt',
      '+245': 'gw',
      '+592': 'gy',
      '+852': 'hk',
      '+504': 'hn',
      '+385': 'hr',
      '+509': 'ht',
      '+36': 'hu',
      '+62': 'id',
      '+353': 'ie',
      '+972': 'il',
      '+91': 'in',
      '+246': 'io',
      '+964': 'iq',
      '+98': 'ir',
      '+354': 'is',
      '+39': 'it',
      '+962': 'jo',
      '+81': 'jp',
      '+254': 'ke',
      '+996': 'kg',
      '+855': 'kh',
      '+686': 'ki',
      '+269': 'km',
      '+850': 'kp',
      '+82': 'kr',
      '+965': 'kw',
      '+7': 'kz',
      '+856': 'la',
      '+961': 'lb',
      '+423': 'li',
      '+94': 'lk',
      '+231': 'lr',
      '+266': 'ls',
      '+370': 'lt',
      '+352': 'lu',
      '+371': 'lv',
      '+218': 'ly',
      '+212': 'ma',
      '+377': 'mc',
      '+373': 'md',
      '+382': 'me',
      '+261': 'mg',
      '+692': 'mh',
      '+389': 'mk',
      '+223': 'ml',
      '+95': 'mm',
      '+976': 'mn',
      '+853': 'mo',
      '+596': 'mq',
      '+222': 'mr',
      '+356': 'mt',
      '+230': 'mu',
      '+960': 'mv',
      '+265': 'mw',
      '+52': 'mx',
      '+60': 'my',
      '+258': 'mz',
      '+264': 'na',
      '+687': 'nc',
      '+227': 'ne',
      '+234': 'ng',
      '+505': 'ni',
      '+31': 'nl',
      '+47': 'no',
      '+977': 'np',
      '+674': 'nr',
      '+683': 'nu',
      '+64': 'nz',
      '+968': 'om',
      '+507': 'pa',
      '+51': 'pe',
      '+689': 'pf',
      '+675': 'pg',
      '+63': 'ph',
      '+92': 'pk',
      '+48': 'pl',
      '+970': 'ps',
      '+351': 'pt',
      '+680': 'pw',
      '+595': 'py',
      '+974': 'qa',
      '+262': 're',
      '+40': 'ro',
      '+381': 'rs',
      '+250': 'rw',
      '+966': 'sa',
      '+677': 'sb',
      '+248': 'sc',
      '+249': 'sd',
      '+46': 'se',
      '+65': 'sg',
      '+290': 'sh',
      '+386': 'si',
      '+421': 'sk',
      '+232': 'sl',
      '+378': 'sm',
      '+221': 'sn',
      '+252': 'so',
      '+597': 'sr',
      '+211': 'ss',
      '+239': 'st',
      '+503': 'sv',
      '+963': 'sy',
      '+268': 'sz',
      '+235': 'td',
      '+228': 'tg',
      '+66': 'th',
      '+992': 'tj',
      '+690': 'tk',
      '+670': 'tl',
      '+993': 'tm',
      '+216': 'tn',
      '+676': 'to',
      '+90': 'tr',
      '+688': 'tv',
      '+886': 'tw',
      '+255': 'tz',
      '+380': 'ua',
      '+256': 'ug',
      '+44': 'gb',
      '+1': 'us',
      '+598': 'uy',
      '+998': 'uz',
      '+58': 've',
      '+84': 'vn',
      '+678': 'vu',
      '+681': 'wf',
      '+685': 'ws',
      '+967': 'ye',
      '+27': 'za',
      '+260': 'zm',
      '+263': 'zw',
    };
  }

  public objectMask() {
    return {
      ac: '9999',
      ad: '999-999',
      ae: '99-999-9999',
      af: '99-999-9999',
      ag: '(999)999-9999',
      ai: '(999)999-9999',
      al: '(999)999-999',
      am: '99-999-999',
      an: '9999-9999',
      ao: '(999)999-999',
      aq: '999-999',
      ar: '(999)999-9999',
      as: '(999)999-9999',
      at: '(999)999-9999',
      au: '9-9999-9999',
      aw: '999-9999',
      az: '99-999-99-99',
      ba: '99-99999',
      bb: '(999)999-9999',
      bd: '99-999-999',
      be: '(999)999-999',
      bf: '99-99-9999',
      bg: '(999)999-999',
      bh: '9999-9999',
      bi: '99-99-9999',
      bj: '99-99-9999',
      bm: '(999)999-9999',
      bn: '999-9999',
      bo: '9-999-9999',
      br: '(99)99999-9999',
      bs: '(999)999-9999',
      bt: '99-999-999',
      bw: '99-999-999',
      by: '(99)999-99-99',
      bz: '999-9999',
      ca: '(999)999-9999',
      cd: '(999)999-999',
      cf: '99-99-9999',
      cg: '99-999-9999',
      ch: '99-999-9999',
      ci: '99-999-999',
      ck: '99-999',
      cl: '9-9999-9999',
      cm: '9999-9999',
      cn: '(999)9999-9999',
      co: '(999)999-9999',
      cr: '9999-9999',
      cu: '9-999-9999',
      cv: '(999)99-99',
      cw: '999-9999',
      cy: '99-999-999',
      cz: '(999)999-999',
      de: '(9999)999-9999',
      dj: '99-99-99-99-99',
      dk: '99-99-99-99-99',
      dm: '(999)999-9999',
      do: '(999)999-9999',
      dz: '99-999-9999',
      ec: '99-999-9999',
      ee: '9999-9999',
      eg: '(999)999-9999',
      er: '9-999-999',
      es: '(999)999-999',
      et: '99-999-9999',
      fi: '(999)999-99-99',
      fj: '99-99999',
      fk: '99999',
      fm: '999-9999',
      fo: '999-999',
      fr: '(999)999-999',
      ga: '9-99-99-99-99',
      gd: '(999)999-9999',
      ge: '(999)999-999',
      gf: '99999-9999',
      gh: '(999)999-999',
      gi: '999-99999',
      gl: '99-99-99-99',
      gm: '(999)99-99',
      gn: '99-999-999',
      gq: '99-999-9999',
      gr: '(999)999-9999',
      gt: '9-999-9999',
      gu: '(999)999-9999',
      gw: '9-999999',
      gy: '999-9999',
      hk: '9999-9999',
      hn: '9999-9999',
      hr: '99-999-999',
      ht: '99-99-9999',
      hu: '(999)999-999',
      id: '(999)999-99-999',
      ie: '(999)999-999',
      il: '99-999-9999',
      in: '(9999)999-999',
      io: '999-9999',
      iq: '(999)999-9999',
      ir: '(999)999-9999',
      is: '999-9999',
      it: '(999)9999-999',
      jm: '(999)999-9999',
      jo: '9-9999-9999',
      jp: '(999)999-999',
      ke: '999-999-9999',
      kg: '(999)999-999',
      kh: '99-999-999',
      ki: '99-999',
      km: '99-99999',
      kn: '(999)999-9999',
      kp: '999-9999-999',
      kr: '99-999-9999',
      kw: '9999-9999',
      ky: '(999)999-9999',
      kz: '(999)999-99-99',
      la: '(9999)999-999',
      lb: '99-999-999',
      lc: '(999)999-9999',
      li: '(999)999-9999',
      lk: '99-999-9999',
      lr: '99-999-999',
      ls: '9-999-9999',
      lt: '(999)99-999',
      lu: '(999)999-999',
      lv: '99-999-999',
      ly: '99-999-999',
      ma: '99-9999-999',
      mc: '(999)999-999',
      md: '9999-9999',
      me: '99-999-999',
      mg: '99-99-99999',
      mh: '999-9999',
      mk: '99-999-999',
      ml: '99-99-9999',
      mm: '99-999-999',
      mn: '99-99-9999',
      mo: '9999-9999',
      mp: '(999)999-9999',
      mq: '(999)99-99-99',
      mr: '99-99-9999',
      ms: '(999)999-9999',
      mt: '9999-9999',
      mu: '999-9999',
      mv: '999-9999',
      mw: '9-9999-9999',
      mx: '(999)999-9999',
      my: '(999)999-999',
      mz: '99-999-999',
      na: '99-999-9999',
      nc: '99-9999',
      ne: '99-99-9999',
      nf: '999-999',
      ng: '(999)999-9999',
      ni: '9999-9999',
      nl: '99-999-9999',
      no: '(999)99-999',
      np: '99-999-999',
      nr: '999-9999',
      nu: '9999',
      nz: '(999)999-999',
      om: '99-999-999',
      pa: '999-9999',
      pe: '(999)999-999',
      pf: '99-99-99',
      pg: '(999)99-999',
      ph: '(999)999-9999',
      pk: '(999)999-9999',
      pl: '(999)999-999',
      ps: '99-999-9999',
      pt: '99-999-9999',
      pw: '999-9999',
      py: '(999)999-999',
      qa: '9999-9999',
      re: '99999-9999',
      ro: '99-999-9999',
      rs: '99-999-9999',
      ru: '(999)999-99-99',
      rw: '(999)999-999',
      sa: '(9999) 999 999',
      sb: '999-9999',
      sc: '9-999-999',
      sd: '99-999-9999',
      se: '99-999-9999',
      sg: '9999-9999',
      sh: '9999',
      si: '99-999-999',
      sk: '(999)999-999',
      sl: '99-999999',
      sm: '9999-999999',
      sn: '99-999-9999',
      so: '99-999-999',
      sr: '999-9999',
      ss: '99-999-9999',
      st: '99-99999',
      sv: '99-99-9999',
      sx: '(999)999-9999',
      sy: '99-9999-999',
      sz: '99-99-9999',
      tc: '(999)999-9999',
      td: '99-99-99-99',
      tg: '99-999-999',
      th: '99-999-9999',
      tj: '99-999-9999',
      tk: '9999',
      tl: '999-9999',
      tm: '9-999-9999',
      tn: '99-999-999',
      to: '99999',
      tr: '(999)999-9999',
      tt: '(999)999-9999',
      tv: '999999',
      tw: '9-9999-9999',
      tz: '99-999-9999',
      ua: '(99)999-99-99',
      ug: '(999)999-999',
      gb: '99-9999-999999',
      us: '(999)999-9999',
      uy: '9-999-99-99',
      uz: '99-999-9999',
      va: '9-999-99999',
      vc: '(999)999-9999',
      ve: '(999)999-9999',
      vg: '(999)999-9999',
      vi: '(999)999-9999',
      vn: '(999)9999-999',
      vu: '99-99999',
      wf: '99-9999',
      ws: '99-9999',
      ye: '999-999-999',
      za: '99-999-9999',
      zm: '99-999-9999',
      zw: '9-999999',
    };
  }

  public ddiPaises() {
    return {
      2: '+971',
      9: '+244',
      26: '+591',
      27: '+55',
      33: '+1',
      38: '+41',
      41: '+56',
      62: '+34',
      69: '+33',
      71: '+44',
      86: '+245',
      100: '+39',
      103: '+81',
      123: '+352',
      144: '+52',
      172: '+595',
      170: '+351',
      214: '+598',
      230: '+1',
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/instituicao/instituicao.ts